/**
 * All user-visible text strings for OnBoarding components.
 * Keep every label, placeholder, tooltip, and aria-label here
 * so copy changes happen in one place.
 */
export const ONBOARDING_TEXT = {
  // DocumentField
  DOC_VIEW_BTN: "View",
  DOC_CLOSE_BTN: "Close",

  // RejectionPanel
  REJECTION_CANCEL_BTN: "Cancel",
  REJECTION_CONFIRM_BTN: "Confirm Rejection",

  // DriverVerificationPanel – header
  DVP_HEADER_TITLE_PREFIX: "Driver Verification:",
  DVP_CLOSE_ARIA: "Close",

  // DriverVerificationPanel – section actions
  DVP_REJECT_BTN: "Reject",
  DVP_UNDO_BTN: "Undo",
  DVP_REJECT_TOOLTIP: "Please view all documents before rejecting this section",
  DVP_REJECTED_PREFIX: "Rejected:",

  // DriverVerificationPanel – footer
  DVP_FOOTER_REJECT_BTN: "Reject",
  DVP_FOOTER_APPROVE_BTN: "Approve",

  // ImageCarousel / ZoomOverlay – accessibility
  CAROUSEL_PREV_ARIA: "Previous image",
  CAROUSEL_NEXT_ARIA: "Next image",
  ZOOM_CLOSE_ARIA: "Close zoom",
  IMAGE_ALT_PREFIX: "Document page",
  PREVIEW_ALT_PREFIX: "Preview",
} as const;
